import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { monthEndAlertConstants } from '../../actions/constant';
import monthEndAlertsService from '../../../services/apiServices/monthEndAlert/monthEndALerts';

const { GET_THEME_COUNT_REQUEST, GET_THEME_COUNT_SUCCESS, GET_THEME_COUNT_FAILURE } =
  monthEndAlertConstants;

function* getMonthEndAlertThemeCount(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(monthEndAlertsService.getMonthEndAlertThemeCount, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_THEME_COUNT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_THEME_COUNT_FAILURE, payload: error });
  }
}

function* getMonthEndAlertThemeCountSaga() {
  yield takeEvery(GET_THEME_COUNT_REQUEST, getMonthEndAlertThemeCount);
}

export default getMonthEndAlertThemeCountSaga;
